import { getFormattedHeaderAndTitle } from "../../../utils/teacher/InputRatingUtils";

const matchGle = (gle, std, contentId) => {
    if (String(gle.key) !== String(contentId) && String(gle.gradeToContentKey) !== String(contentId)) return null;
    return {
        contentType: "GLE",
        label: gle.gleName,
        header: gle.gleName?.replace(/^\d+\.\s*/, "").slice(0, 25) || "",
        standardName: std.standardName,
        standardKey: std.key ?? std.cdestandardId ?? std.id ?? null,
        gleName: gle.gleName,
        gleKey: gle.key ?? gle.gleId ?? null,
        eoName: null
    };
};

const matchEo = (eo, gle, std, contentId) => {
    if (String(eo.key) !== String(contentId)) return null;
    const { header } = getFormattedHeaderAndTitle(eo.body || "");
    return {
        contentType: "EVIDENCE_OUTCOME",
        label: eo.body,
        header,
        standardName: std.standardName,
        standardKey: std.key ?? std.cdestandardId ?? std.id ?? null,
        gleName: gle.gleName,
        gleKey: gle.key ?? gle.gleId ?? null,
        eoName: null
    };
};

const matchEoChild = (child, eo, gle, std, contentId) => {
    if (String(child.key) !== String(contentId)) return null;
    const { header } = getFormattedHeaderAndTitle(child.body || "");
    return {
        contentType: "EVIDENCE_OUTCOME_CHILD",
        label: child.body,
        header,
        standardName: std.standardName,
        standardKey: std.key ?? std.cdestandardId ?? std.id ?? null,
        gleName: gle.gleName,
        gleKey: gle.key ?? gle.gleId ?? null,
        eoName: eo.body
    };
};

const findInStandard = (std, contentId) => {
    for (const gle of std.gles || []) {
        const gleMatch = matchGle(gle, std, contentId);
        if (gleMatch) return gleMatch;
        for (const eo of gle.evidenceOutcomes || []) {
            const eoMatch = matchEo(eo, gle, std, contentId);
            if (eoMatch) return eoMatch;
            for (const child of eo.evidenceOutcomeChildList || []) {
                const childMatch = matchEoChild(child, eo, gle, std, contentId);
                if (childMatch) return childMatch;
            }
        }
    }
    return null;
};

export const lookupDiffItemText = (reportableContent, grade, contentId) => {
    if (!reportableContent?.gradeLevels) return null;
    const gradeNode = reportableContent.gradeLevels.find((gl) => gl.gradeLevel === grade);
    if (!gradeNode) return null;
    for (const std of gradeNode.cdeStandards || []) {
        const match = findInStandard(std, contentId);
        if (match) return match;
    }
    return null;
};

/** Profile/student_diff rows may omit grade; search every grade band (parent preview + roster). */
export const lookupDiffItemAcrossGrades = (reportableContent, contentId) => {
    if (!reportableContent?.gradeLevels || contentId == null) return null;
    for (const gl of reportableContent.gradeLevels) {
        const text = lookupDiffItemText(reportableContent, gl.gradeLevel, contentId);
        if (text) return { ...text, grade: gl.gradeLevel };
    }
    return null;
};

export const enrichItemsByGrade = (itemsByGrade, reportableContent) => {
    const next = {};
    Object.entries(itemsByGrade || {}).forEach(([grade, items]) => {
        next[grade] = items.map((item) => {
            const text = lookupDiffItemText(reportableContent, grade, item.contentId);
            return text ? { ...item, ...text } : item;
        });
    });
    return next;
};
